import Canje from "./Canje";
import { withRouter } from "react-router-dom";

export default withRouter(Canje);
